module.exports = __webpack_public_path__ + "img/bank-note.7429cca0.svg";